import {
  isRefreshPaymentRequiredError,
  REFRESH_PAYMENT_REQUIRED_MESSAGE,
} from "~/api/battery-financing-errors"
import type { BatteryProposalFinancingDto } from "~/api/dto/battery-proposal.dto"
import useApplyBatteryCreditHumanApplication from "~/api/hooks/useApplyBatteryCreditHumanApplication"
import useCalculateBatteryPayment from "~/api/hooks/useCalculateBatteryPayment"
import useFetchActiveLoanActivity from "~/api/hooks/useFetchActiveLoanActivity"
import useMarkApprovedBatteryCreditHumanApplication from "~/api/hooks/useMarkApprovedBatteryCreditHumanApplication"
import useReopenBatteryCreditHumanApplication from "~/api/hooks/useReopenBatteryCreditHumanApplication"
import useReplaceBatteryCreditHumanApplication from "~/api/hooks/useReplaceBatteryCreditHumanApplication"

import type { FinancingKindBundle } from "../../ProposalSetup/financing/financing-kind-bundle"

export const SAVE_AND_CALCULATE_LABEL = `Save & Calculate Payment`
export const PAYMENT_UNAVAILABLE_PROMPT = `Credit Human did not return a monthly payment. Your Loan Product is saved.`
export const PAYMENT_RETRY_PROMPT = `Run ${SAVE_AND_CALCULATE_LABEL} again to retry.`
export const SAVED_AND_CALCULATED_LABEL = `Loan Product saved and payment calculated`
export const SAVED_WITHOUT_PAYMENT_LABEL = `Loan Product saved. No payment was calculated.`
export const CALCULATE_PAYMENT_ERROR_PROMPT = `Unable to calculate the payment. Your selection is still here.`

/** Battery-Only Proposal reads and commands for the shared financing pieces. */
export const batteryFinancingBundle: FinancingKindBundle<BatteryProposalFinancingDto> =
  {
    testIdPrefix: `battery`,
    loanProduct: {
      // Battery's read lists only eligible Loan Products.
      options: (financing) =>
        financing.eligibleLoanProducts.map((product) => ({
          ...product,
          availability: `eligible`,
        })),
      useSave: useCalculateBatteryPayment,
      showOptionTerms: false,
      copy: {
        saveLabel: SAVE_AND_CALCULATE_LABEL,
        savingLabel: `Calculating`,
        savedLabel: SAVED_AND_CALCULATED_LABEL,
        savedWithoutPaymentLabel: SAVED_WITHOUT_PAYMENT_LABEL,
        saveErrorPrompt: CALCULATE_PAYMENT_ERROR_PROMPT,
        paymentUnavailablePrompt: PAYMENT_UNAVAILABLE_PROMPT,
        paymentRetryPrompt: PAYMENT_RETRY_PROMPT,
      },
    },
    creditHuman: {
      useApply: useApplyBatteryCreditHumanApplication,
      useReopen: useReopenBatteryCreditHumanApplication,
      useReplace: useReplaceBatteryCreditHumanApplication,
      useMarkApproved: useMarkApprovedBatteryCreditHumanApplication,
      useActivity: useFetchActiveLoanActivity,
      isRefreshRequiredError: isRefreshPaymentRequiredError,
      // Battery's Credit Human status explains the refusal without a button.
      RefreshPricing: null,
      copy: { refreshRequired: REFRESH_PAYMENT_REQUIRED_MESSAGE },
    },
  }
